var map = {
	"./1 Artworks.png": 2699,
	"./Ali.png": 3327,
	"./Burhan.png": 5971,
	"./Cederqvist.png": 8571,
	"./Efraimsson.png": 6302,
	"./Englund.png": 8756,
	"./Fredell.png": 8127,
	"./Mårtensson.png": 2839,
	"./Reed.png": 5819,
	"./Runarsdotter.png": 4248,
	"./Sokolova.png": 8299,
	"./Yeh.png": 1201,
	"./Åberg.png": 3536
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 2896;